export default function RequiredAsterisk() {
  return (
    <span className="text-sm inline-block font-[SimSun] me-1 text-[#ff4d4f]">
      *
    </span>
  );
}
